export default "/images/hy-room-tour-desktop.png?5b38f69f5bf609e4e1c02792e950f900";